import { Accordion, Attribute, CustomMobileAccordionType, Icon, MatchUp, Typography } from "best-common-react";
import { Link } from "react-router";
import React from "react";
import RouteConstants, { urlReplace } from "../../constants/RouteConstants";
import { useTimezone } from "../../util/TimeUtil";
import { EventTableData } from "./EventsTable";

const ActiveValue = ({ value }: { value: boolean }) => (value ? <Icon iconName="fa fa-check" /> : null);

const EventsAccordion = ({ data, ...rest }: CustomMobileAccordionType<EventTableData>) => {
  const {
    id,
    location,
    game,
    date: gameDate,
    hasOverrides,
    venue,
    venueBlackedOut,
    eventBlackedOut,
    dayOfRequestCancelled,
  } = data;
  const { time, day, date } = useTimezone(gameDate.gameDate, gameDate.tz, game.status);
  return (
    <Accordion {...rest}>
      <Accordion.Header>
        <div className="d-flex justify-content-between align-items-start bcr-gap-2">
          <Link
            to={{
              pathname: urlReplace(RouteConstants.ADMIN.EVENTS_EDIT, { eventId: id }),
            }}
            state={{ previousLocation: location }}
          >
            <Typography variant="titleMedium" elementStyles={{ weight: "bold" }}>
              {date}
            </Typography>
          </Link>
          <MatchUp home={game.home} away={game.away} description={game.seriesDescription} />
        </div>
        <div className="d-flex justify-content-between align-items-end">
          <Typography>
            {day}
            <span className="bcr-ms-2">{time}</span>
          </Typography>
          {hasOverrides && <Typography variant="labelSmall">override(s)</Typography>}
        </div>
      </Accordion.Header>
      <Accordion.Body>
        <div className="bcr-px-2">
          <Attribute
            horizontal
            header="Venue"
            value={<Typography>{venue}</Typography>}
            className="justify-content-between bcr-py-1"
          />
          <Attribute
            horizontal
            header="Venue Requests"
            value={<Typography>{venueBlackedOut ? "On" : "Off"}</Typography>}
            className="justify-content-between bcr-py-1"
          />
          <Attribute
            horizontal
            header="Game Blackout"
            value={<ActiveValue value={eventBlackedOut} />}
            className="justify-content-between bcr-py-1"
          />
          <Attribute
            horizontal
            header="Today's Tickets Requests Cancelled"
            value={<ActiveValue value={dayOfRequestCancelled} />}
            className="justify-content-between bcr-py-1"
          />
        </div>
      </Accordion.Body>
    </Accordion>
  );
};

export default EventsAccordion;
